import { render, staticRenderFns } from "./CircleDrawer.vue?vue&type=template&id=3981b606&scoped=true&"
import script from "./CircleDrawer.vue?vue&type=script&lang=ts&"
export * from "./CircleDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./CircleDrawer.vue?vue&type=style&index=0&id=3981b606&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3981b606",
  null
  
)

export default component.exports